import React, { type MouseEvent, type ReactNode } from 'react';
import { Link as DSLink, Typography } from '@saviynt/design-system';

import { TNC_MESSAGE_PATTERN } from '../constants';
import { type ParsedTnCMessage } from '../types';

import styles from '../../features/FormPreview/components/PreviewFields/PreviewFields.module.css';

const parseTnCMessage = (message: string | undefined): ParsedTnCMessage => {
  if (!message) {
    return { before: '', link: null, after: '' };
  }

  const match = TNC_MESSAGE_PATTERN.exec(message);

  if (!match) {
    return { before: message, link: null, after: '' };
  }

  const link = match[2].trim();

  return {
    before: match[1],
    link: link || null,
    after: match[3],
  };
};

// eslint-disable-next-line import/prefer-default-export
export const buildTnCMessageNodes = (
  tncMessage: string,
  handleLinkClick: (event: MouseEvent) => void,
  isCanvas?: boolean
): ReactNode[] => {
  const parsed = parseTnCMessage(tncMessage);

  if (!tncMessage) {
    return [];
  }

  const hasLink = Boolean(parsed.link);

  if (hasLink) {
    return [
      <Typography key='inline' kind='body2'>
        {parsed.before}
        <DSLink
          kind='button'
          text={parsed.link as string | number | undefined}
          tabIndex={isCanvas ? -1 : 0}
          onClick={handleLinkClick}
          className={styles.tncMessage}
        />
        {/*  eslint-disable-next-line formatjs/no-literal-string-in-jsx -- is defined by user */}
        {parsed.after ? `${parsed.after}` : ''}
      </Typography>,
    ];
  }

  return [
    <Typography key='full' kind='body2'>
      {tncMessage}
    </Typography>,
  ];
};

export default buildTnCMessageNodes;
